import { all, call, put, takeLatest } from 'redux-saga/effects'
import store from 'store'
import AuthActions, { AuthTypes } from 'Redux/AuthRedux'

// Storage keys
const TOKEN_KEY = 'video_panda_token'
const USER_KEY = 'video_panda_user'
const TEAM_KEY = 'video_panda_team'

// Startup saga - initialize auth from stored data
export function* startup(api, action) {
  try {
    const token = store.get(TOKEN_KEY)
    const storedUser = store.get(USER_KEY)
    const teamId = store.get(TEAM_KEY)

    if (!token) {
      // No token, user is not authenticated
      yield put(AuthActions.startupComplete())
      if (action.callback) {
        action.callback(false)
      }
      return
    }

    // Set auth headers
    yield call(api.setAuthData, { token, teamId })

    // Validate token by getting current user
    const resp = yield call(api.getCurrentUser)

    if (resp.ok) {
      const { user, teams } = resp.data
      
      // Update stored user data
      store.set(USER_KEY, user)
      
      // Set team if not already set
      const currentTeamId = teamId || teams?.[0]?.id
      if (currentTeamId && !teamId) {
        store.set(TEAM_KEY, currentTeamId)
        yield call(api.setTeamId, currentTeamId)
      }

      yield put(AuthActions.setAuthData({ token, teamId: currentTeamId }))
      yield put(AuthActions.getCurrentUserSuccess(user, teams))
      yield put(AuthActions.startupComplete())
      
      if (action.callback) {
        action.callback(true, user)
      }
    } else {
      // Token invalid, clear stored data
      store.remove(TOKEN_KEY)
      store.remove(USER_KEY)
      store.remove(TEAM_KEY)
      yield call(api.deleteAuthData)
      
      yield put(AuthActions.clearAuthData())
      yield put(AuthActions.startupComplete())
      
      if (action.callback) {
        action.callback(false)
      }
    }
  } catch (error) {
    console.error('Startup error:', error)
    yield put(AuthActions.startupComplete())
    if (action.callback) {
      action.callback(false)
    }
  }
}

// Watcher saga
export default function* startupSaga(api) {
  yield all([
    takeLatest(AuthTypes.STARTUP_REQUEST, startup, api),
  ])
}
